import React, {useState, useEffect} from 'react';
import '../profilesettings.css';
import { actualizarInfoEstudiante } from '../../../services/EstudianteService';
import { useUser } from '../../../context/userContext';
import { MdEmail, MdOutlineDriveFileRenameOutline } from 'react-icons/md';
import { BsFillTelephoneFill, BsFacebook} from 'react-icons/bs';
import { FaClipboard, FaInstagram, FaLinkedin} from 'react-icons/fa';
import { FaSquareXTwitter } from "react-icons/fa6";
import Swal from 'sweetalert2';


function PersonalInfo(){
    const { userData, updateUserData } = useUser();
    const [phone, setPhone] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [facebook, setFacebook] = useState('');
    const [instagram, setInstagram] = useState('');
    const [twitter, setTwitter] =  useState('');
    const [linkedin, setLinkedin] = useState('');
  
    useEffect(() => {
      setPhone(userData.telefonoCelular);
      setDescripcion(userData.descripcion);
      setFacebook(userData.facebook);
      setInstagram(userData.instagram);
      setTwitter(userData.twitter);
      setLinkedin(userData.linkedin);
    },[userData])
  
    const handleUpdatePersonalInfo = async (e) => {
      e.preventDefault();
      try{
        const updatedData = {
          cif: userData.cif,
          telefonoCelular: phone,
          descripcion: descripcion,
          facebook: facebook,
          instagram: instagram,
          twitter: twitter,
          linkedin: linkedin
        };
        // Asumiendo que tienes una función para hacer la solicitud PUT
        await actualizarInfoEstudiante (updatedData);
        updateUserData(updatedData);
        Swal.fire({
          title:'Datos guardados con éxito.', 
          icon:'success',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#21807C'
        });
      }catch(e){
        Swal.fire(e.message);
      }
  
    }
  
    return(
      <div className='profile-contenido'>
        <form onSubmit={handleUpdatePersonalInfo}>
          <div className='personalinfo-container'>
            <div>
            <h4>Nombre Completo:</h4>
            <div className='personalinfo-input'>
              <FaClipboard size={19}/>
              <input disabled value={userData.nombreCompleto || ''} style={{ color: 'gray'}}/>
            </div>
            </div>
            
            <div>
              <h4>Correo Institucional:</h4>
              <div className='personalinfo-input'>
                <MdEmail size={20}/>
                <input disabled value={userData.correoInstitucional || ''} style={{ color: 'gray'}}/>
              </div>
            </div>
            <div>
              <h4>Número de teléfono:</h4>
              <div className='personalinfo-input'>
                <BsFillTelephoneFill size={20}/>
                <input type='tel' placeholder='Ingresa tu número de teléfono' value={phone || ''} onChange={(e) => setPhone(e.target.value)} />
              </div>
            </div>
            <div>
              <h4>Descripción:</h4>
              <div className='personalinfo-input'>
                <MdOutlineDriveFileRenameOutline size={25}/>
                <input type='tel' placeholder='Ejemplo: Mi escritor favorito es Edgar Allan Poe, etc.' value={descripcion || ''} onChange={(e) => setDescripcion(e.target.value)}/>
              </div>
            </div>
          </div>
          <h3>Redes Sociales:</h3>
          <div className='personalinfo-container'>
            <div className='personalinfo-input'>
              <BsFacebook size={20}/>
              <input type='url' placeholder='https://facebook.com/juanitoalcachofa' value={facebook || ''} onChange={(e) => setFacebook(e.target.value)}/>
            </div>
            <div className='personalinfo-input'>
              <FaInstagram size={20}/>
              <input type='url' placeholder='https://instagram.com/juanitoalcachofa' value={instagram || ''} onChange={(e) => setInstagram(e.target.value)}/>
            </div>
            <div className='personalinfo-input'>
              <FaSquareXTwitter size={20}/>
              <input type='url' placeholder='https://twitter.com/juanitoalcachofa' value={twitter || ''} onChange={(e) => setTwitter(e.target.value)}/>
            </div>
            <div className='personalinfo-input'>
              <FaLinkedin size={20}/>
              <input type='url' placeholder='https://linkedin.com/juanitoalcachofa' value={linkedin || ''} onChange={(e) => setLinkedin(e.target.value)}/>
            </div>
          </div>
          <button type='submit' style={{ marginTop: '2rem'}} className='profile-btnUsado'>Guardar</button>
        </form>
      </div>
    )
  }

  export default PersonalInfo;